import { motion } from "framer-motion";
import { Heartbeat, ChartLineUp, Brain, Users } from "@phosphor-icons/react";

const pillars = [
  {
    icon: Heartbeat,
    title: "Health",
    desc: "Sustainable energy through sleep, nutrition and movement — measured, not guessed.",
    span: "lg:col-span-7",
  },
  {
    icon: ChartLineUp,
    title: "Wealth",
    desc: "Rewire your money story and build durable financial confidence.",
    span: "lg:col-span-5",
  },
  {
    icon: Brain,
    title: "Mindset",
    desc: "Train focus, resilience and calm under pressure.",
    span: "lg:col-span-5",
  },
  {
    icon: Users,
    title: "Relationships",
    desc: "Communicate with clarity and build partnerships that grow with you.",
    span: "lg:col-span-7",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Pillars = () => {
  return (
    <section id="pillars" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
        <div>
          <span className="overline">Four pillars, one you</span>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-brand-text mt-4 max-w-2xl">
            A whole-person method for a whole life.
          </h2>
        </div>
        <p className="text-brand-dim max-w-sm">
          Real change rarely lives in a single area. TonyBrand29 coaches across
          the four forces that shape a thriving life.
        </p>
      </div>

      <div className="grid lg:grid-cols-12 gap-5">
        {pillars.map((p, i) => (
          <motion.div
            key={p.title}
            data-testid={`pillar-${p.title.toLowerCase()}`}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className={`${p.span} group relative rounded-3xl border border-brand-line bg-brand-surface p-8 lg:p-12 overflow-hidden hover:border-brand-sage/50 transition-colors duration-500`}
          >
            <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-brand-sage/5 blur-2xl group-hover:bg-brand-gold/10 transition-colors duration-500" />
            <p.icon size={40} weight="thin" className="text-brand-gold mb-8" />
            <h3 className="font-serif text-3xl lg:text-4xl text-brand-text mb-3">
              {p.title}
            </h3>
            <p className="text-brand-dim max-w-md leading-relaxed">{p.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
